<div class="course-list">
    <div *ngIf="showSpinner" class="progress-spinner">
        <mat-spinner></mat-spinner>
    </div>
    <div class="intro">
        <h2 class="mat-display-2">Liste der Kurse</h2>
    </div>

    <!-- <mat-toolbar class="admin-toolbar">
      <ul>
          <li>
              <a mat-button routerLink="/projects/list">Projekte verwalten</a>
          </li>
      </ul>
    </mat-toolbar> -->

    <div class="list">
        <div mat-icon-button mat-card-avatar class="create" routerLink="create">
          <mat-icon color="primary">add_circle_outline</mat-icon>
        </div>
       <!--  <div class="mat-display-1">
            Kursliste
        </div> -->
    
        <mat-form-field>
            <input (keyup)="applyFilter($event)" matInput placeholder="Filter">
        </mat-form-field>
    
        <div class="mat-elevation-z8">
            <table mat-table [dataSource]="dataSource" matSort>
              
              <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef> No. </th>
                <td mat-cell *matCellDef="let i = index"> {{this.paginator.pageIndex == 0 ? i + 1 : 1 + i + this.paginator.pageIndex * this.paginator.pageSize}} </td>
              </ng-container>
            
              <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Titel </th>
                <td mat-cell *matCellDef="let course"> 
                  <a routerLink="{{course.id}}">{{course.title}}</a> </td>
              </ng-container>

              <ng-container matColumnDef="content">
                <th mat-header-cell *matHeaderCellDef> Beschreibung </th>
                <td mat-cell *matCellDef="let course"> 
                  <a routerLink="{{course.id}}">{{course.content}}</a> </td>
              </ng-container>

              <ng-container matColumnDef="category_id">
                <th mat-header-cell *matHeaderCellDef> Kategorie </th>
                <td mat-cell *matCellDef="let course"> 
                  <a routerLink="{{course.id}}">{{course.category_name}}</a> </td>
              </ng-container>

              <ng-container matColumnDef="course_fees">
                <th mat-header-cell *matHeaderCellDef> Kursgebühren </th>
                <td mat-cell *matCellDef="let course">
                  <a routerLink="{{course.id}}">{{course.course_fees}}</a> </td>
              </ng-container>

              <ng-container matColumnDef="director">
                <th mat-header-cell *matHeaderCellDef> Leitung </th>
                <td mat-cell *matCellDef="let course">
                  <a routerLink="{{course.id}}">{{course.lead}}</a> </td>
              </ng-container>
            
              <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef>Kurs-Nr. </th>
                <td mat-cell *matCellDef="let course"> 
                  <a routerLink="{{course.id}}">{{course.code}}</a> </td>
              </ng-container>
  
              <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef> Bearbeiten </th>
                <td mat-cell *matCellDef="let course">
                  <button mat-icon-button routerLink="{{course.id}}/edit">
                    <mat-icon>edit</mat-icon>
                  </button>
                </td>
              </ng-container>
      
              <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef> Löschen </th>
                <td mat-cell *matCellDef="let course">
                  <button mat-icon-button (click)="deleteCourse(course)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>
            
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </div>
</div>
